const dir = $('html').prop('dir');

$(document).ready(function() {
  (function () {
    var $header = $('.j-header-box');
    if($header.length === 0){
      return;
    }
    if ($(window).width() > 992 && !$('body').hasClass('product-product') && !$header.is(":hidden")) {
      let [_headerBox, _headerBoxH, _headerBoxBottom] = [$header, $header.outerHeight(), $header.offset().top + $header.outerHeight()];

      $(window).scroll(function () {
        if ($(this).scrollTop() + 80 > _headerBoxBottom) {
          _headerBox.addClass('header-fixed');
          if ($('.menu-old').length > 0) return;
          _headerBox.before('<div class="menu-old" style="height:' + _headerBoxH + 'px; width:100%;"></div>');
        } else {
          _headerBox.removeClass('header-fixed');
          $('.menu-old').remove();
        }

      });
    }
  })();

  $('.scroll-top').on('click', function(event) {
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0} , 'fast');
  });

  // 子导航菜单 偏移量计算
  if ($(window).width() > 992) {
    $('.side-menu .dropdown-menu').each(function () {
      let width = $(this).outerWidth();
      let margin = dir == 'rtl' ? 'margin-rgiht' : 'margin-left';

      $(this).css(margin, '-' + width / 2 + 'px');
    });
  }

  // 响应式侧边菜单栏
  $(document).on('click', '.mobile-nav-icon, .mobile-search', function (event) {
    $('.side-menu').fadeIn(0).children('.side-inner').addClass('active');
  });

  $(document).on('click', '.side-menu', function (e) {
    if ($(e.target).closest('.side-inner').length === 0) {
      $('.side-menu .side-inner').removeClass('active');
      setTimeout("$('.side-menu').fadeOut(50)", 220);
    }
  });

  $('.side-menu li .toggle-button').click(function(event) {
    $(this).parent().siblings().removeClass('open active').children('.dropdown-menu').slideUp();
    $(this).parent().toggleClass('active').find('.dropdown-menu').slideToggle("fast");
  });

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  // Currency
  $('#form-currency .currency-select').on('click', function(e) {
    e.preventDefault();

    $('#form-currency input[name=\'code\']').val($(this).attr('name'));

    $('#form-currency').submit();
  });

  // Language
  $('#form-language .language-select').on('click', function(e) {
    e.preventDefault();

    $('#form-language input[name=\'code\']').val($(this).attr('name'));

    $('#form-language').submit();
  });

  /* Search */
  $('#search span').on('click', function() {
    var url = '';

    var value = $('#header-search-input').val();

    gioEvarAction.searchEvar(value);
    //预置搜索词
    var presetWord = $("#search input").attr('placeholder');

    if (value) {
      $("#search").removeClass('error');
      $("#search input").attr('placeholder','搜索');
      url = solution_host + '/list' + '?type=' + window.cateData.searchType + '&kw=' + encodeURIComponent(value) + '&searchmodule=商城'
      if(value === presetWord){
        location = url + '&ishot=4';
      }else{
        location = url;
      }
    }else {
      $("#search").addClass('error');
      $("#search").addClass('error-shake');
      $("#search input").attr('placeholder','请输入搜索内容');
      setTimeout(function () {
        $("#search").removeClass('error-shake');
      },300)
    }

    // gio 搜索埋码
    // gio('track', 'eshop_searchSuccess', {
    //   eshop_searchwords: encodeURIComponent(value),
    // });


  });

  $('#search input[name=\'search\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#search span').trigger('click');
    }
  });
  $('#search .hot-search-content ul li').on('click', function () {
    console.log($(this).text())
    $('#search input[name=\'search\']').val($(this).text());
    // $('#search input[name=\'search\']').siblings('span').trigger('click');
    $('#search .hot-search-content').hide();
  })


  $('#search input[name=\'search\']').on('focus', function () {
    var searchText = $('#search input[name=\'search\']').val();
    if(!searchText){
      $('#search  .hot-search-content').show()
    }
  });
  $(document).click(function(e){
    var _con = $('#search');
    if(!_con.is(e.target) && _con.has(e.target).length === 0){
      $('#search .hot-search-content').hide();
    }
  });


  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });

  $('.more-review').on('click', function(e) {
    e.preventDefault();
    $("html, body").stop().animate({ scrollTop: $('.nav-tabs').offset().top }, 400);
    $('a[href=\'#tab-review\']').trigger('click');
  })

  $(document).on('click', '#review .pagination a', function(e) {
    e.preventDefault();
    $('#review').load(this.href);
  });

  var outJsonDebugContentIsShwo = true;
  $('.out-json-debug-mini').on('click', function (e) {
    if(outJsonDebugContentIsShwo){
      $('.out-json-debug-content').hide();
      $('.out-json-debug-mini').html('[+]');
    }else{
      $('.out-json-debug-content').show();
      $('.out-json-debug-mini').html('[-]');
    }
    outJsonDebugContentIsShwo = !outJsonDebugContentIsShwo;
  });

  /* Agree to Terms */
  $(document).on('click', '.agree', function(e) {
    e.preventDefault();

    var $element = $(this);

    layer.open({
      type: 2,
      title: $element.text(),
      skin: 'agree-to-terms',
      area: ['80%', '72%'],
      content: [$element.attr('href')],
    });
  });
});
